export default __webpack_public_path__ + "static/media/red_card_icon.6a06357b.svg";